import React, { useState, useEffect } from 'react'
import {
  Datagrid,
  TextField,
  useTranslate,
  useResourceContext,
  useResourceDefinitions,
  Pagination,
  ListContextProvider,
  ListToolbar,
  useList,
  DateField,
  TextInput,
  useRedirect,
  ChipField,
  useRecordContext,
  useStore,
  Button,
} from 'react-admin'
import { Container } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { setResourceProps } from 'src/helper/resourceProps'
import { ListViewTopToolbar } from 'src/components/uiElements/CRUD/ListViewTopToolbar'
import { businessRuleServices } from 'src/services/sales/businessRule/businessRule.service'
import { useParams, useLocation } from 'react-router-dom'
import { DetailVersionButton } from 'src/components/uiElements/buttons/DetailVersionButton'

function BusinessRuleVersionsList() {
  const { id } = useParams()
  const translate = useTranslate()
  const [isLoading, setIsLoading] = useState(false)
  const [sort, setSort] = useState({ field: 'id', order: 'ASC' })
  const [filter, setFilter] = useState({})
  const [displayedFilters, setDisplayedFilters] = useState({})
  const [versions, setVersions] = useStore(' BusinessRule.versions', [])
  setResourceProps(useResourceDefinitions(), useResourceContext())

  useEffect(() => {
    if (id) {
      getVersions(id)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getVersions = async (rule_id) => {
    try {
      setIsLoading(true)
      const versions = await businessRuleServices.getVertions(rule_id)
      let version_with_unique_id = await Promise.all(
        versions.map(async (item) => {
          item.id = item.id + '_' + item.version
          return item
        })
      )
      if (version_with_unique_id) {
        setVersions(version_with_unique_id)
        setIsLoading(false)
        return
      }
      setVersions([])
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      setVersions([])
    }
  }

  const listContext = useList({
    data: versions,
    isLoading,
    sort,
    page: 1,
    perPage: 10,
  })

  const onShowFilter = (filterName) => {
    setDisplayedFilters((displayedFilters) => ({
      ...displayedFilters,
      [filterName]: true,
    }))
  }

  const onHideFilter = (filterName) => {
    const displayedFiltersAux = { ...displayedFilters }
    delete displayedFiltersAux[filterName]
    setDisplayedFilters(displayedFiltersAux)
    const filterAux = { ...filter }
    delete filterAux[filterName]
    setFilter(filterAux)
  }

  const onChangeFilters = (filters, displayedFiltersAux) => {
    Object.entries(filters).forEach((elem) => {
      const [key, value] = elem
      if (!value) {
        delete filters[key]
      }
    })

    setFilter(filters)
    setDisplayedFilters(displayedFiltersAux)
  }

  const BusinessRuleVersionFilters = [
    <TextInput label={translate('ra.field.id')} source='id' defaultValue='' />,
  ]
  return (
    <Container className='content'>
      <CardCommon title={translate('ra.entity.versions')}>
        <ListContextProvider
          value={{
            ...listContext,
            displayedFilters: displayedFilters,
            setFilters: onChangeFilters,
            showFilter: onShowFilter,
            hideFilter: onHideFilter,
          }}
        >
          <>
            <ListToolbar actions={<ListViewTopToolbar />} filters={BusinessRuleVersionFilters} />
            <Datagrid setSort={setSort} isLoading={isLoading} bulkActionButtons={<></>}>
              <TextField label={translate('ra.field.version_number')} source='version' />
              <TextField label={translate('ra.field.name')} source='name' />
              <DateField label={translate('ra.field.update_at')} showTime source='transaction.issued_at' />
              <ChipField label={translate('ra.field.modify_by')} source='transaction.user_data.username' />
              <DetailVersionButton />
            </Datagrid>
            <Pagination />
          </>
        </ListContextProvider>
      </CardCommon>
    </Container>
  )
}

export default BusinessRuleVersionsList
